import { FunctionComponent } from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { RootState } from '../../store/reducers';
import UserAdmin from './UserAdmin/UserAdmin';
import UserAdminList from './UsersAdminList/UsersAdminList';

const UsersAdmin: FunctionComponent = () => {
  const { path } = useRouteMatch();
  const authSeqReady = useSelector((state: RootState) => state.authentication.authSequenceReady);
  return (
    <Switch>
      <Route path={`${path}/usergroup/:usergroupid/user/:id`} component={UserAdmin} />
      <Route exact path={path} component={UserAdminList} />
      {authSeqReady && <Redirect to="/users" />}
    </Switch>
  );
};

export default UsersAdmin;
